import React from 'react';
import {
  BarChart2,
  TrendingUp,
  PieChart,
  Activity
} from 'lucide-react';

const AnalyticsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-950">
      {/* Header */}
      <div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-3 py-2">
          <div>
            <h1 className="text-base font-bold text-gray-900 dark:text-white">Analytics Dashboard</h1>
            <p className="text-gray-600 dark:text-gray-300">Track performance metrics across all operations</p>
          </div>
        </div>
      </div>

      {/* Empty State */}
      <div className="max-w-7xl mx-auto px-3 py-16">
        <div className="text-center">
          <div className="flex justify-center gap-4 mb-2">
            <div className="w-16 h-16 bg-gray-200 dark:bg-gray-800 rounded-lg flex items-center justify-center">
              <BarChart2 className="w-5 h-5 text-gray-400" />
            </div>
            <div className="w-16 h-16 bg-gray-200 dark:bg-gray-800 rounded-lg flex items-center justify-center">
              <TrendingUp className="w-5 h-5 text-gray-400" />
            </div>
            <div className="w-16 h-16 bg-gray-200 dark:bg-gray-800 rounded-lg flex items-center justify-center">
              <PieChart className="w-5 h-5 text-gray-400" />
            </div>
            <div className="w-16 h-16 bg-gray-200 dark:bg-gray-800 rounded-lg flex items-center justify-center">
              <Activity className="w-5 h-5 text-gray-400" />
            </div>
          </div>
          <h2 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">Analytics Coming Soon</h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto">
            Business analytics and reporting features are under development.
            Track revenue, project performance, and team metrics here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPage;
